var render = function render(){var _vm=this,_c=_vm._self._c;return _c('quill-editor',{ref:"myTextEditor",staticClass:"editor",class:{ 'editor--auto-grow': _vm.autoGrow },attrs:{"value":_vm.content,"options":_vm.editorOption,"disabled":_vm.disabled},on:{"change":_vm.onEditorChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }